export default (params) => ({
  trigger: {
    name: 'item_card.click_reviews_in_item_card',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'read_reviews',
      params: {
        sub_feature: null,
      },
    },
  },
});
